import { render } from "./SavedTablesBackToSearch.vue?vue&type=template&id=ffb9d7e2&scoped=true"
import script from "./SavedTablesBackToSearch.vue?vue&type=script&lang=js"
export * from "./SavedTablesBackToSearch.vue?vue&type=script&lang=js"

import "./SavedTablesBackToSearch.vue?vue&type=style&index=0&id=ffb9d7e2&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb9d7e2"]])

export default __exports__